module.exports = __webpack_public_path__ + "static/media/5.2d8b6dc5.JPG";